import React from 'react';
import './WordCard.sass'

function WordCard({bgColor, children, className}) {
    return (
        <div className={`word_card ${className}`} style={{backgroundColor: bgColor}}>
            {children}
        </div>
    );
}

export default WordCard;